import { Component } from "@angular/core";
import { first } from 'rxjs/operators'
import { BsModalService } from 'ngx-bootstrap/modal';
import { ChangeEventComponent } from './change-event/change-event.component';
import { ParsEventService } from '../../pars/pars-event.service';
import { EventModel } from '../../api/models/event-model';
import { BaseViewComponent } from '../../../../shared/core/interfaces/baseViewComponent';
import { LookupService } from '../../../../shared/core/services/lookup.service';

@Component({
  selector: 'current-event',
  templateUrl: './current-event.component.html',
  styleUrls: ['./current-event.component.scss']
})
export class CurrentEventComponent extends BaseViewComponent {
  currentEvent: EventModel = {};

  constructor(
    private _parsEventService: ParsEventService,
    private modalService: BsModalService,
    lookupService: LookupService) {
    super(lookupService);
    this.safeSubscribe(this._parsEventService.currentEvent$, event => this.currentEvent = event);
  }

  changeEvent(event: EventModel, clickEvent?) {
    let activeElement = document.activeElement;
    let pointerType = clickEvent ? clickEvent.pointerType : '';

    const modal = this.modalService.show(ChangeEventComponent, { backdrop: 'static', class: 'gray modal-lg' });
    modal.content.event = event;

    modal.onHide.pipe(first()).subscribe(() => {
      if (activeElement && activeElement instanceof HTMLElement) {
        activeElement.focus();
        if (pointerType == "mouse") activeElement.blur();
      }
    });
    this.safeSubscribe(modal.content.update, data => {
      this.currentEvent = data;
      this._parsEventService.loadCurrentEvent();
    });
  }
}
